import { lazy } from "react";
import type { RouteObject } from "react-router";

import { loader } from "./loader.ts";

export const inviteRoute: RouteObject = {
  handle: {
    disableHeaderNavigation: true,
  },
  path: "invites/:token",
  loader,
  Component: lazy(() => import("./InvitePage.tsx")),
};
